import React, { useRef, useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import {
  Box,
  Typography,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
  ImageList,
  ImageListItem,
  Button,
  Grid,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  CardMedia,
  Avatar,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Autocomplete,
  Tooltip,
  IconButton,
  CardContent,
  MobileStepper,
  ListItem,
  ListItemIcon,
  List,
  ListItemText,
} from '@mui/material';
import {
  AcUnit,
  Bathtub,
  BedOutlined,
  Business,
  CleaningServices,
  DirectionsBus,
  DirectionsWalk,
  DryCleaning,
  Elevator,
  Email,
  Group,
  Kitchen,
  LocalLaundryService,
  LocationOn,
  MenuBook,
  Microwave,
  NightsStay,
  Pets,
  Phone,
  Security,
  SmokeFree,
  Star,
  Train,
  Tv,
  Weekend,
  Wifi,
  LocalParking,
  KingBed,
  Hvac,
  DryCleaningOutlined,
  Deck,
  SmokingRooms,
  Add,
  Assignment,
  People,
  KeyboardArrowRight,
  KeyboardArrowLeft,
  Male,
  Female,
  Person,
  FiberManualRecord,
  DirectionsCar,
  Info,
  ExpandMore,
  CalendarToday,
} from '@mui/icons-material';
import DashboardCard from '../../../components/shared/DashboardCard';
import { IconParking } from '@tabler/icons-react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { Stack, useMediaQuery, useTheme } from '@mui/system';
import axios from 'axios';
import { fget, fpost } from '../../../axios/axiosCalls';
import toast from 'react-hot-toast';
import NoImageFound from '../../../components/NoImageFound';
import { calculateLeaseDuration, formatDateRange, formatDateToDDMMYYYY, priceFormattingSymbol } from '../../../utils/utils';
import AddCustomerForm from '../../../components/AddCustomerForm';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { terms } from './terms';
import { GridCloseIcon } from '@mui/x-data-grid';
import PaymentTermsFull from '../../../components/Terms';
import Footer from '../../../components/Footer';
import { de } from 'date-fns/locale';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Add the plugin for custom parsing
dayjs.extend(customParseFormat);
// Add this helper function at the top of the file
const calculateLeaseStartDate = (moveInDate) => {
  const date = new Date(moveInDate);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  
  // Create new date for 1st or 16th of the month
  return new Date(year, month, day <= 15 ? 1 : 16);
};

// At the top of the file, add a date formatting helper
const formatDateForURL = (date) => {
  
  return new Date(date).toISOString().split('T')[0];
};

const RoomMates = ({ rooms }) => {
  const occupiedRooms = rooms?.filter(room =>
    room.beds.list.some(bed => bed.isAllotted === 1)
  );

  if (!occupiedRooms || occupiedRooms.length === 0) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          Current Tenants
        </Typography>
        <Card sx={{
          p: 4,
          textAlign: 'center',
          // backgroundColor: 'grey.50'
        }}>
          <People sx={{
            fontSize: 48,
            color: 'text.secondary',
            mb: 2
          }} />
          <Typography variant="h6" color="text.secondary">
            No Current Tenants
          </Typography>
          <Typography variant="body2" color="text.secondary">
            There are no tenants currently staying in this property.
          </Typography>
        </Card>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Current Tenants
      </Typography>
      <Grid container spacing={3}>
        {occupiedRooms.map((room) => (
          <Grid item xs={12} key={room.roomTitle}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              {room.roomTitle}
            </Typography>
            <Grid container spacing={2}>
              {room.beds.list.filter(bed => bed.isAllotted === 1).map((bed) => (
                <Grid item xs={12} sm={6} md={4} key={bed.id}>
                  <Card sx={{
                    p: 2,
                    boxShadow: (theme) => theme.shadows[2],
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    transition: 'box-shadow 0.3s ease-in-out',
                    '&:hover': {
                      boxShadow: (theme) => theme.shadows[4]
                    }
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar>
                        {bed.tenancy?.studentDetails?.name?.charAt(0).toUpperCase() || 'T'}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1">
                          {bed.tenancy?.studentDetails?.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {bed.bedSpace}
                        </Typography>
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="caption" color="text.secondary">
                            Duration: {bed.tenancy?.weeksCount} weeks
                          </Typography>
                          <Typography variant="caption" display="block" color="text.secondary">
                            {new Date(bed.tenancy?.startDate).toLocaleDateString()} - {new Date(bed.tenancy?.endDate).toLocaleDateString()}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
const TermsAndCond = ({ propertyData, propertyType = 'managingProperties' }) => {
  const paymentTerms = propertyData?.paymentTerms;

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
        Terms & Conditions 
      </Typography>
      {propertyData?.managingType?.code === 'one_time' && (
            <ListItem sx={{ py: 0.25 }}>
              
              <ListItemText 
                primary={`For all one-time properties, there will be a service charge of ${propertyData?.country?.currencyCode || '$'} ${propertyData?.paymentTerms?.serviceCharge || 0}`}
                primaryTypographyProps={{ 
                  variant: 'body2',
                  fontWeight: "bold",
                  lineHeight: 1.8,

                  fontSize: '0.875rem'
                }} 
              />
            </ListItem>
          )}
      {paymentTerms ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pl:2 }}>
          {paymentTerms?.terms?.length>0&&<Box>
            <Typography variant="subtitle1" color="primary" gutterBottom>
              Payment Terms
            </Typography>
            <List dense>
              {paymentTerms?.terms?.map((term, index) => (
                <ListItem key={index} sx={{ py: 0.25 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}>
                    <FiberManualRecord sx={{ fontSize: 6 }} />
                  </ListItemIcon>
                  <ListItemText 
                    primary={term}
                    primaryTypographyProps={{ 
                      variant: 'body2',
                      fontSize: '0.875rem',
                      lineHeight: 1.8
                    }} 
                  />
                </ListItem>
              ))}
            </List>
          </Box>}
          
          {/* <Box>
            <Typography variant="subtitle1" color="primary" gutterBottom>
               Conditions
            </Typography>
            <List dense>
              {paymentTerms.conditions.summary.map((condition, index) => (
                <ListItem key={index} sx={{ py: 0.25 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}>
                    <FiberManualRecord sx={{ fontSize: 6 }} />
                  </ListItemIcon>
                  <ListItemText 
                    primary={condition}
                    primaryTypographyProps={{ 
                      variant: 'body2',
                      fontSize: '0.875rem'
                    }} 
                  />
                </ListItem>
              ))}
            </List>
          </Box> */}

          {paymentTerms?.conditions?.detailed?.length>0&&<Box>
            <Typography variant="subtitle1" color="primary" gutterBottom>
              Conditions
            </Typography>
            <List dense>
              {paymentTerms?.conditions?.detailed.map((condition, index) => (
                <ListItem key={index} sx={{ py: 0.25 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}>
                    <FiberManualRecord sx={{ fontSize: 6 }} />
                  </ListItemIcon>
                  <ListItemText 
                    primary={condition}
                    primaryTypographyProps={{ 
                      variant: 'body2',
                      fontSize: '0.875rem',
                      lineHeight: 1.8

                    }} 
                  />
                </ListItem>
              ))}
            </List>
          </Box>}
        </Box>
      ) : (
        <Card sx={{ p: 3, textAlign: 'center' }}>
          <Assignment sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
          <Typography variant="subtitle1" color="text.secondary">
            No Terms & Conditions Available
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Terms and conditions have not been added for this property yet.
          </Typography>
        </Card>
      )}
    </Box>
  );
};
const HouseRules = ({ propertyRules }) => {

  if (!propertyRules || propertyRules.length === 0) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          House Rules
        </Typography>
        <Card sx={{
          p: 4,
          textAlign: 'center',
        }}>
          <MenuBook sx={{
            fontSize: 48,
            color: 'text.secondary',
            mb: 2
          }} />
          <Typography variant="h6" color="text.secondary">
            No House Rules Available
          </Typography>
          <Typography variant="body2" color="text.secondary">
            House rules have not been added for this property yet.
          </Typography>
        </Card>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        House Rules
      </Typography>
      <Grid container spacing={2}>
        {propertyRules.map((item) => (
          <Grid item xs={12} sm={3} key={item.id}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                borderRadius: 1,
                border: (theme) => `1px solid ${theme.palette.divider}`,
                bgcolor: 'background.paper',
                boxShadow: (theme) => theme.shadows[2],
              }}
            >
              <MenuBook sx={{ color: 'primary.main' }} />
              <Box>
                <Typography variant="subtitle2">{item.rule}</Typography>
                {/* <Typography variant="caption" color="text.secondary">
                  Added on: {new Date(item.createdAt).toLocaleDateString()}
                </Typography> */}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const OwnerDetails = ({ owner }) => {

  return (

    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Owner Details
      </Typography>
      {owner ? (
        <Card sx={{ p: 3 }}>
          <Grid container spacing={4}>
            {/* Left Column - Avatar & Name */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Avatar src={owner.profilePhoto} sx={{ width: 50, height: 50 }}>
                  {owner.name?.charAt(0)}
                </Avatar>
                <Box>
                  <Typography variant="body">{owner.name || 'N/A'}</Typography>
                  {owner.hostExperience && (
                    <Typography variant="body2" color="text.secondary">
                      {owner.hostExperience}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Right Column - Contact Info */}
            {/* <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Contact Information
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email fontSize="small" color="primary" />
                <Typography variant="body2">{owner.email || 'N/A'}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone fontSize="small" color="primary" />
                <Typography variant="body2">{owner.phone || 'N/A'}</Typography>
              </Box>
            </Box>
          </Grid> */}
          </Grid>
        </Card>) : (
        <Card sx={{
          p: 4,
          textAlign: 'center',
          // boxShadow: (theme) => theme.shadows[2],
          // border: (theme) => `1px solid ${theme.palette.divider}`,
        }}>
          <Business sx={{
            fontSize: 48,
            color: 'text.secondary',
            mb: 2
          }} />
          <Typography variant="h6" color="text.secondary">
            No Owner Details Available
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Owner information has not been added for this property yet.
          </Typography>
        </Card>
      )}
    </Box>
  );
};
// Add new component GuarantorForm
const GuarantorForm = ({ onSubmit, onClose, selectedCustomer }) => {
  const [formData, setFormData] = useState({
    type: 'local',
    name: '',
    email: '',
    phone: '',
    country: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [countries, setCountries] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoadingCountries(true);
        const response = await fget({ url: '/api/v2/countries?all=1' });
        if (response.data.status === 'Success') {
          const countries = response.data.data.map((country,index )=> ({
            name: country.cname,
            id: index,
            states: country.states || [], // Extract states,
            nationality: country.nationality
          }));
          // Sort countries alphabetically
          countries.sort((a, b) => a.name.localeCompare(b.name));
          setCountries(countries);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        setError('Failed to load countries');
      } finally {
        setLoadingCountries(false);
      }
    };

    fetchCountries();
  }, []);
  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');

      // Call API to add guarantor
      const response = await fpost({
        url: `/api/v2/channelpartner/students/${selectedCustomer.studentId}`,
        data: {
          "guarantor":{
          "type": formData.type,
          "name": formData.name,
          "email": formData.email,
          "phone": formData.phone,
          "country": formData.country
        }}
      });

      if (response.data.status === 'Success') {
        // toast.success('Guarantor added successfully');
        onSubmit(formData);
      } else {
        setError('Failed to add guarantor');
        // toast.error('Failed to add guarantor');
      }
    } catch (error) {
      setError(error?.response?.data?.message || 'Failed to add guarantor');
      toast.error(error?.response?.data?.message || 'Failed to add guarantor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DialogTitle>Add Guarantor Details</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Guarantor Type</InputLabel>
            <Select
              value={formData.type}
              onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
              label="Guarantor Type"
            >
              <MenuItem value="local">Local</MenuItem>
              <MenuItem value="international">International</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Guarantor Name"
            fullWidth
            
            value={formData.name}
            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
          />
          <TextField
            label="Email"
            type="email"
            fullWidth
            
            value={formData.email}
            onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
          />
          <TextField
            label="Phone"
            fullWidth
            
            value={formData.phone}
            onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
          />
          {formData.type === "international" &&<FormControl fullWidth>
            <InputLabel>Country</InputLabel>
            <Select
              value={formData.country}
              onChange={(e) => setFormData(prev => ({ ...prev, country: e.target.value }))}
              label="Country"
              disabled={loadingCountries}
            >
              {countries.map((country) => (
                <MenuItem key={country.id} value={country.name}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
            {loadingCountries && (
              <CircularProgress 
                size={20} 
                sx={{ 
                  position: 'absolute',
                  right: 25,
                  top: '50%',
                  marginTop: '-10px'
                }} 
              />
            )}
          </FormControl>}
          
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Back</Button>
        <Button 
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Next'}
        </Button>
      </DialogActions>
    </>
  );
};

// Update BookingModal component
const BookingModal = ({ open, onClose, selectedRoom, propertyData, isEnquiry, propertyId, defaultStartDate,setFromDate }) => {
  const [bookingData, setBookingData] = useState({
    customerId: null,
    propertyId: propertyData?.id,
    bedSpaceId: selectedRoom?.id,
    startDate: defaultStartDate , // Set default start date
    endDate: null,
    message: '',
    college: '',
    campus: '',
    intake: '',
    travelDate: null,
    leaseStartDate: defaultStartDate ? calculateLeaseStartDate(defaultStartDate).toISOString().split('T')[0] : null,
    leaseEndDate: selectedRoom?.endDate?.formatted || null,
  });
  
  const [customers, setCustomers] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showGuarantorForm, setShowGuarantorForm] = useState(false);
  const [guarantorData, setGuarantorData] = useState(null);

  const validateForm = () => {
    const newErrors = {};
    
    // Required fields
    if (!bookingData.customerId) {
      newErrors.customerId = 'Student selection is required';
    }
    
    if (!bookingData.startDate) {
      newErrors.startDate = 'Check-in date is required';
    }
    
    // if (!bookingData.endDate) {
    //   newErrors.endDate = 'Move-out date is required';
    // }
    
    // Date validation
    if (selectedRoom?.startDate && selectedRoom?.endDate) {
      const availableStart = new Date(selectedRoom.startDate.formatted);
      const availableEnd = new Date(selectedRoom.endDate.formatted);
      const selectedStart = new Date(bookingData.startDate);
      const selectedEnd = new Date(bookingData.endDate);
    
      if (selectedStart < availableStart) {
        newErrors.startDate = `Check-in date must be after ${availableStart.toLocaleDateString()}`;
      }
      
      // if (selectedEnd > availableEnd) {
      //   newErrors.endDate = `Move-out date must be before ${availableEnd.toLocaleDateString()}`;
      // }
    
      // Check for minimum 12 month duration
      // const months = (selectedEnd.getFullYear() - selectedStart.getFullYear()) * 12 +
      //   (selectedEnd.getMonth() - selectedStart.getMonth());
      
      // if (months < 1) {
      //   newErrors.endDate = 'Booking should be at least be 1 months';
      // }
    }
    
    if (bookingData.travelDate) {
      const travel = new Date(bookingData.travelDate);
      const start = new Date(bookingData.startDate);
      
      // if (travel > start) {
      //   newErrors.travelDate = 'Travel date should be before Check-in date';
      // }
    }
    
    // Gender validation
    const selectedStudent = customers.find(c => c.studentId === bookingData.customerId);
    
    
    const roomGender = getRoomGender(selectedRoom.room, true);
    
    if (roomGender && selectedStudent) {
      
      const studentGender = selectedStudent.gender?.toLowerCase();
      
      if (roomGender !== 'mixed' && studentGender !== roomGender) {
        newErrors.customerId = `This room is ${roomGender} only`;
      }
    }
    
    setErrors(newErrors);
    
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    const fetchCustomers = async () => {
      setLoadingCustomers(true);
      try {
        const response = await fget({ url: '/api/v2/channelpartner/students' });
        if (response.data.status === 'Success') {
          setCustomers(response.data.students);
        }
      } catch (error) {
        console.error('Error fetching customers:', error);
      } finally {
        setLoadingCustomers(false);
      }
    };
    fetchCustomers();
  }, []);
  const handleSubmit = async (providedGuarantorData) => {
    
    setSubmitting(true); // <-- Show loader
    if (!isEnquiry && !validateForm()) {
      setSubmitting(false);
      return;
    }
    
    // Check for guarantor if not enquiry
    const selectedCustomer = customers.find(c => c.studentId === bookingData.customerId);
    const effectiveGuarantor = providedGuarantorData || guarantorData;

    if (!isEnquiry && !selectedCustomer?.guarantor && !effectiveGuarantor) {
      setShowGuarantorForm(true);
      setSubmitting(false);
      return;
    }
    
    try {
      const response = await fpost({
        url: '/api/v2/bookings',
        data: {
          ...bookingData,
          startDate: bookingData.startDate,
          endDate: bookingData.endDate,
          travelDate: bookingData.travelDate,
          bedSpaceId: selectedRoom?.id,
          customName: null,
          name: bookingData.customName || undefined,
          isEnquiry: isEnquiry ? 1 : 0, // Set isEnquiry based on the prop
          guarantor: guarantorData // Add guarantor data if exists
        }
      });

      if (response.data.status === 'Success') {
        let bookingId = response?.data?.booking?.bookingId;
        
        if(isEnquiry){
          toast.success( 'Enquiry created successfully');
        }
        else{
          toast.success(!bookingId ? 'Enquiry created successfully' : 'Booking created successfully');
        }
        console.log("booking",response.data);
        
        onClose();
        if (!isEnquiry&&bookingId) {
          // Add 2 second delay before redirect
          await new Promise(resolve => setTimeout(resolve, 2000));

          const basePath = window.location.pathname.split('/'); // Get first path segment
          
          const paymentPath = `${import.meta.env.VITE_BASE_URL}property/${propertyId}/payments/${response.data?.booking?.bookingId}`;
          window.location.href = paymentPath;
        }
      }
    } catch (error) {
      console.log("error",error);
      toast.error(
        Object.values(error?.response?.data?.errors || {})[0] ||
        error?.response?.data?.message ||
        'Failed to create booking'
      );
    } finally {
      setSubmitting(false);
    }
  };
  const handleGuarantorSubmit = async (data) => {
    setGuarantorData(data);
    setShowGuarantorForm(false);
    // Retry submit after guarantor data is added
    handleSubmit(data);
  };
  const [colleges, setColleges] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [loadingColleges, setLoadingColleges] = useState(false);
  const [loadingCampuses, setLoadingCampuses] = useState(false);

  // Fetch colleges on mount
  useEffect(() => {
    const fetchColleges = async () => {
      setLoadingColleges(true);
      try {
        const response = await fget({
          url: '/api/v2/colleges',
          params: { countryId: propertyData.country.id }
        });
        if (response.data.status === 'Success') {
          setColleges(response.data.colleges);
        }
      } catch (error) {
        console.error('Error fetching colleges:', error);
      } finally {
        setLoadingColleges(false);
      }
    };
    fetchColleges();
  }, [propertyData.country.id]);

  // Fetch campuses when college changes

  // }, [bookingData.college, propertyData.country.id]);
  // useEffect(() => {
    const fetchCampuses = async (collegeId) => {
      if (!bookingData.college) {
        setCampuses([]);
        return;
      }
      setLoadingCampuses(true);
      try {
        let countryId = propertyData.country.id;
        const response = await fget({
          url: '/api/v2/campuses',
          params: {
            collegeId: collegeId,
            countryId: countryId
          }
        });
        if (response.data.status === 'Success') {
          setCampuses(response.data.campuses);
        }
      } catch (error) {
        console.error('Error fetching campuses:', error);
      } finally {
        setLoadingCampuses(false);
      }
    };
  const [showAddCustomer, setShowAddCustomer] = useState(false);

  const handleCustomerSuccess = async (newCustomer) => {
    // Add new customer to list
    setCustomers(prev => [{
      ...newCustomer,
      studentId: newCustomer.id,
      customName: newCustomer.name
    }, ...prev]);

    try {
      // Fetch updated colleges list
      const collegesResponse = await fget({
        url: '/api/v2/colleges',
        params: {
          countryId: newCustomer.toCountry
        }
      });

      if (collegesResponse.data.status === 'Success') {
        setColleges(collegesResponse.data.colleges);
        
        const matchingCollege = collegesResponse.data.colleges.find(c => 
          c.name === newCustomer.college
        );
        const collegeId = matchingCollege?.collegeId || '';

        // Set initial booking data
        setBookingData(prev => ({
          ...prev,
          customerId: newCustomer.id,
          college: collegeId,
          intake: newCustomer.intakeYear || '',
          customName: newCustomer.name
        }));

        // Handle campus list if college exists
        if (matchingCollege) {
          const campusList = matchingCollege.campuses?.map(campus => ({
            id: campus.id,
            campusId: campus.id,
            campusName: campus.campusName,
            name: campus.campusName
          })) || [];

          setCampuses(campusList);

          const matchingCampus = campusList.find(c => 
            c.campusName.toLowerCase() === newCustomer.campus?.toLowerCase()
          );

          if (matchingCampus) {
            setBookingData(prev => ({
              ...prev,
              campus: matchingCampus.campusId,
              college: collegeId,
              intake: newCustomer.intakeYear || '',
              customName: newCustomer.name
            }));
          }
        }
      }
    } catch (error) {
      console.error('Error fetching colleges:', error);
      toast.error('Failed to fetch college details');
    }

    setShowAddCustomer(false);
};
  
  const handleCustomerChange = async (event, newValue) => {
    if (!newValue) {
      setBookingData(prev => ({
        ...prev,
        customerId: '',
        college: '',
        campus: '', 
        intake: ''
      }));
      setCampuses([]);
      return;
    }
  
    // Gender validation
    const roomGender = getRoomGender(selectedRoom.room, true);
    const studentGender = newValue.gender?.toLowerCase();
    
    if (roomGender && roomGender !== 'mixed' && studentGender !== roomGender) {
      setErrors(prev => ({
        ...prev,
        customerId: `This room is ${roomGender} only`
      }));
      return;
    }
    
    setLoadingCampuses(true);
    try {
      const collegesResponse = await fget({
        url: '/api/v2/colleges',
        params: {
          countryId: newValue.toCountry
        }
      });
  
      if (collegesResponse.data.status === 'Success') {
        const colleges = collegesResponse.data.colleges;
        setColleges(colleges);
        
        const matchingCollege = colleges.find(c => c.name === newValue.college);
        
        if (matchingCollege) {
          const collegeId = matchingCollege.collegeId;
          
          // Set campuses directly from college data
          const campusList = matchingCollege?.campuses?.map(campus => ({
            id: campus.id,
            campusId: campus.id,
            campusName: campus.campusName,
            name: campus.campusName,
            customName: newValue.name

          })) || [];
          
          setCampuses(campusList);
  
          const matchingCampus = campusList.find(c => 
            c.campusName.toLowerCase() === newValue.campus?.toLowerCase()
          );
          
          setBookingData(prev => ({
            ...prev,
            customerId: newValue.studentId || '',
            college: collegeId,
            intake: newValue.intakeYear || '',
            campus: matchingCampus?.id || '',
            customName: newValue.name
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching colleges:', error);
      toast.error('Failed to fetch college details');
    } finally {
      setLoadingCampuses(false);
    }
  };

  // Add this helper function
  const getDefaultEndDate = (startDate) => {
    if (!startDate) return '';
    
    const date = new Date(startDate);
    if (isNaN(date.getTime())) return '';
    
    // Add 32 days
    const endDate = new Date(date.getTime() + (32 * 24 * 60 * 60 * 1000));
    if (isNaN(endDate.getTime())) return '';
    
    return endDate.toISOString().split('T')[0];
  };

  // Add helper to get today's date in YYYY-MM-DD format
  const getTodayFormatted = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Update validation function
  const validateDates = (startDate, endDate) => {
    const newErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (startDate) {
      const start = new Date(startDate);
      const availableStart = new Date(selectedRoom?.startDate?.formatted);
      const availableEnd = new Date(selectedRoom?.endDate?.formatted);

      // if (start < today) {
      //   newErrors.startDate = 'Check-in date cannot be in the past';
      // } else if (start < availableStart) {
      //   newErrors.startDate = `Check-in date must be after ${availableStart.toLocaleDateString()}`;
      // }

      // if (endDate) {
      //   const end = new Date(endDate);
        
      //   // Calculate months between dates
      //   const months = (end.getFullYear() - start.getFullYear()) * 12 + 
      //                 (end.getMonth() - start.getMonth());
        
      //   if (months < 1) {
      //     console.log("months",months);
      //     newErrors.endDate = 'Booking must be at least 1 months';
      //   }

      //   if (end > availableEnd) {
      //     newErrors.endDate = `Move-out must be before ${availableEnd.toLocaleDateString()}`;
      //   }
      // }
    }
    return newErrors;
  };

  // Add lease date calculation when move-in date changes
  const handleMoveInDateChange = (e) => {
    const newStartDate = e.target.value;
    const leaseStart = calculateLeaseStartDate(newStartDate);
    const defaultEndDate = getDefaultEndDate(newStartDate);
    const maxEndDate = selectedRoom?.endDate?.formatted?.split(' ')[0];
    setFromDate(newStartDate);
    // Update URL
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('fromDate', newStartDate);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);

    const leaseStartDate = isNaN(leaseStart.getTime())
      ? ''
      : leaseStart.toISOString().split('T')[0];
      
    setBookingData(prev => ({ 
      ...prev, 
      startDate: newStartDate,
      endDate: maxEndDate && defaultEndDate > maxEndDate ? maxEndDate : defaultEndDate,
      leaseStartDate, // use the validated string
      leaseEndDate: selectedRoom?.endDate?.formatted?.split(' ')[0]
    }));

    const dateErrors = validateDates(newStartDate, bookingData.endDate);
    setErrors(prev => ({ ...dateErrors}));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {!showGuarantorForm ? (
        <>
          <DialogTitle>{isEnquiry ? 'Enquire Now' : 'Book Room'}</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>

              {selectedRoom?.startDate && selectedRoom?.endDate && (
                <Box sx={{
                  p: 2,
                  // bgcolor: 'info.lighter',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'info.light'
                }}>
                  <Typography variant="subtitle2"  gutterBottom>
                    Available Dates
                  </Typography>
                  <Typography variant="body2">
                  {formatDateRange(new Date().toLocaleDateString(), selectedRoom.endDate.formatted)}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Autocomplete
                    fullWidth
                    options={customers}
                    getOptionLabel={(option) => option.name || ''}
                    value={customers.find(c => c.studentId === bookingData.customerId) || null}
                    onChange={handleCustomerChange}
                    loading={loadingCustomers}
                    //         noOptionsText={
                    //           <Box 
                    //             sx={{ 
                    //               display: 'flex', 
                    //               alignItems: 'center', 
                    //               justifyContent: 'space-between',
                    //               p: 1 
                    //             }}
                    //           >
                    //             <Typography variant="body2">No student found</Typography>
                    //             <Button
                    //               size="small"
                    //               startIcon={<Add />}
                    //               onClick={(e) => {
                    //                 e.stopPropagation();
                    //                 setShowAddCustomer(true);
                    //               }}
                    //             >
                    //               Add New Student
                    //             </Button>
                    //           </Box>
                    // }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Student"
                        fullWidth
                        InputLabelProps={{
                          ...params.InputLabelProps,
                          shrink: true,
                        }}
                        error={!!errors.customerId}
                        helperText={errors.customerId}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingCustomers ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        sx={{ flex: 1 }}
                      />
                    )}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setShowAddCustomer(true)}
                    sx={{ 
                      minWidth: '40px',
                      width: '40px',
                      height: '40px',
                      p: 0,
                      // Align with TextField
                    }}
                  >
                    <Add />
                  </Button>
                </Box>
                {/* <Box sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: 2,
    my: 1 
  }}>
    <Divider sx={{ flex: 1 }} />
    <Typography 
      variant="body2" 
      color="text.secondary"
      sx={{ px: 1 }}
    >
      OR
    </Typography>
    <Divider sx={{ flex: 1 }} />
  </Box> */}

                { isEnquiry&& <TextField
                  label="Enter Student Name"
                  fullWidth
                  value={bookingData.customName || ''}
                  onChange={(e) => setBookingData(prev => ({
                    ...prev,
                    customId: '',
                    customName: e.target.value
                  }))}
                  error={!!errors.customerId}
                  helperText={errors.customerId}
                  disabled={bookingData.customerId}
                />}


              </Box>

              <TextField
                type="text"
                label="Check-in Date" 
                disabled
                error={!!errors.startDate}
                helperText={errors.startDate}
                InputLabelProps={{ shrink: true }}
                value={formatDateToDDMMYYYY(defaultStartDate)}
                onChange={handleMoveInDateChange}
                inputProps={{
                  min: getTodayFormatted(),
                  max: selectedRoom?.endDate?.formatted?.split(' ')[0]
                }}
              />

              {/* <TextField
 Date"
  error={!!errors.endDate}  type="date"
  label="Move-out
  helperText={errors.endDate} 
  InputLabelProps={{ shrink: true }}
  value={bookingData.endDate}
  onChange={(e) => {
    const newEndDate = e.target.value;
    setBookingData(prev => ({ ...prev, endDate: newEndDate }));
    
    // Validate dates
    const dateErrors = validateDates(bookingData.startDate, newEndDate);
    setErrors(prev => ({...prev, ...dateErrors}));
  }}
  inputProps={{
    min: bookingData.startDate,
    max: selectedRoom?.endDate?.formatted?.split(' ')[0]
  }}
/> */}
              {defaultStartDate && !isEnquiry && (
                <Box sx={{
                  p: 2,
                  bgcolor: 'info.lighter',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'info.light',
                  mb: 2
                }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Rent Agreement
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                      Start Date: {formatDateToDDMMYYYY(calculateLeaseStartDate(defaultStartDate))}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                       End Date: {formatDateToDDMMYYYY(selectedRoom?.endDate?.formatted )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              )}
              <TextField
                label="Message"
                multiline
                rows={3}
                value={bookingData.message}
                onChange={(e) => setBookingData(prev => ({ ...prev, message: e.target.value }))}
              />
              <FormControl fullWidth>
                <InputLabel>College</InputLabel>
                <Select
                  value={bookingData.college}
                  onChange={(e) => {
                    const selectedCollegeId = e.target.value;
                    const selectedCollege = colleges.find(c => c.collegeId === selectedCollegeId);
                    
                    // Map campuses from college object
                    const campusList = selectedCollege?.campuses?.map(campus => ({
                      id: campus.id,
                      campusId: campus.id,
                      campusName: campus.campusName,
                      name: campus.campusName
                    })) || [];
                    
                    // Update states
                    setBookingData(prev => ({ 
                      ...prev, 
                      college: selectedCollegeId,
                      campus: '' // Reset campus when college changes
                    }));
                    setCampuses(campusList);
                  }}
                  label="College"
                  disabled={loadingColleges}
                >
                  {colleges.map((college) => (
                    <MenuItem key={college.collegeId} value={college.collegeId}>
                      {college.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Campus</InputLabel>
                <Select
                  value={bookingData.campus}
                  onChange={(e) => setBookingData(prev => ({ ...prev, campus: e.target.value }))}
                  label="Campus"
                  disabled={loadingCampuses || !bookingData.college}
                >
                  {campuses.map((campus) => (
                    <MenuItem key={campus.id} value={campus.id}>
                      {campus.campusName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Intake"
                value={bookingData.intake}
                onChange={(e) => setBookingData(prev => ({ ...prev, intake: e.target.value }))}
              />
              {/* // Replace the existing TextField for travel date with: */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Travel Date"
                  value={bookingData.travelDate ? dayjs(bookingData.travelDate) : null}
                  onChange={(newValue) => {
                    if (!newValue || !newValue.isValid()) return;
                    setBookingData(prev => ({ 
                      ...prev, 
                      travelDate: newValue.format('YYYY-MM-DD')
                    }));
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      error: !!errors.travelDate,
                      helperText: errors.travelDate,
                      fullWidth: true
                    }
                  }}
                />
              </LocalizationProvider>

              {/* Add Lease Dates Display */}

            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              onClick={()=>handleSubmit()}
              variant="contained"
              disabled={submitting} // <-- Disable while loading
              sx={{ 
                minHeight: 36,
                position: 'relative'
              }}
            >
              {submitting ? (
                <CircularProgress 
                  size={24}
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px'
                  }}
                />
              ) : (
                isEnquiry ? 'Confirm' : 'Book and continue'
              )}
            </Button>
            {/* {selectedRoom?.bookingAvailable&&<Button 
          onClick={()=>{handleSubmit('pay')}}
          variant="contained"
          disabled={!bookingData.customerId || !bookingData.startDate || !bookingData.endDate}
        >
          Confim & Pay
        </Button>} */}
          </DialogActions>
          <Dialog open={showAddCustomer} onClose={() => setShowAddCustomer(false)} maxWidth="md" fullWidth>
            <DialogTitle>Add New Student</DialogTitle>
            <DialogContent>
              <AddCustomerForm onSuccess={handleCustomerSuccess} />
            </DialogContent>
          </Dialog>
        </>
      ) : (
        <GuarantorForm 
          onSubmit={handleGuarantorSubmit}
          onClose={() => setShowGuarantorForm(false)}
          selectedCustomer={customers.find(c => c.studentId === bookingData.customerId)}
        />
      )}
    </Dialog>
  );
};
const getRoomGender = (room,type) => {
  const beds = type? room :room?.beds?.list;
  if (!beds?.length) return null;
  
  // Get all genders including undefined/null
  const allGenders = beds.map(bed => 
    bed.tenancy?.studentDetails?.gender?.toLowerCase()
  );
  
  // Filter defined genders
  const definedGenders = allGenders.filter(g => g);
  
  // If no defined genders, room is open
  if (!definedGenders.length) return null;
  
  // Check if all defined genders are same
  const maleCount = definedGenders.filter(g => g === 'male').length;
  const femaleCount = definedGenders.filter(g => g === 'female').length;
  
  if (maleCount > 0 && femaleCount === 0) return 'male';
  if (femaleCount > 0 && maleCount === 0) return 'female';
  // If both male and female exist
  return null;
};
const Overview = ({ selectedRoom, rooms, onRoomSelect, propertyData, isEnquiry, setIsEnquiry,propertyId, defaultStartDate,setFromDate }) => {
  const [expanded, setExpanded] = useState(false);
  const [duration, setDuration] = useState(4);
  const durations = [4, 8, 16, 20, 24, 'Custom'];
  const price = parseFloat(selectedRoom?.paymentSplit?.bedRatePerMonth) || 150;
  const isRoomAvailable = selectedRoom && !selectedRoom.isAllotted;
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const convertAmenityToNumber = (value) => {
    if (!value) return 0;
    
    if (typeof value === 'number') return value;
    
    if (value === 'yes' || value === true) return 1;
    
    const numValue = parseInt(value);
    return isNaN(numValue) ? 0 : numValue;
  };

  const [selectedCollege, setSelectedCollege] = useState(null);
  const [selectedCampus, setSelectedCampus] = useState(null);

  const formatDistance = (meters) => {
    if (meters < 1000) {
      return `${meters}m`;
    }
    return `${(meters/1000).toFixed(1)}km`;
  };

  const formatTime = (seconds) => {
    const minutes = Math.round(seconds/60);
    if (minutes < 60) {
      return `${minutes} mins`;
    }
    const hours = Math.floor(minutes/60);
    const remainingMins = minutes % 60;
    return `${hours}h ${remainingMins}m`;
  };

  // Add state for check-in date
  const [startDate, setStartDate] = useState(defaultStartDate );

  // Add helper to get today's date in YYYY-MM-DD format
  const getTodayFormatted = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const handleDateChange = (newDate) => {
    setStartDate(newDate);
    // Update URL with new date without page reload
    setFromDate(newDate);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('fromDate', newDate);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  };

  // Update booking modal opening to pass the current check-in date
  const handleOpenBooking = (isEnquiry) => {
    setIsEnquiry(isEnquiry);
    setIsBookingModalOpen(true);
  };

  return (
    <Grid container spacing={3}>
      {/* Left Column */}
      <Grid item xs={12} md={8}>
        {/* Property Stats */}
        <Box
         sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'row', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexWrap: 'wrap',
          gap: { xs: 1.5, sm: 2.5 },
          mb: { xs: 3, sm: 4 }
        }}
         >
          <Box
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'wrap'
          }} 
          >
          <Typography variant="h6" color="text.secondary"
          // sx={{ 
          //   fontSize: { xs: '1rem', sm: '1.1rem' },
          //   fontWeight: 500
          // }}
          >
            {rooms.length > 0 ? rooms.reduce((acc, room) => acc + room.beds.total, 0) : 0} bed spaces
          </Typography>
          <Typography variant="h6" color="text.secondary"
          sx={{ 
            // display: { xs: 'none', sm: 'block' },
            fontSize: { xs: '1.1rem', sm: '1.2rem' }
          }}
          >
            •
          </Typography>
          </Box>
          <Box
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            gap: 1.5
          }}
          >
          <Typography variant="h6" color="text.secondary"
             sx={{ 
              fontSize: { xs: '1rem', sm: '1.1rem' },
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: 1 
            }}
          >
            {rooms.length} bedrooms
          </Typography>
          <Typography variant="h6" color="text.secondary"
            sx={{ 
              // display: { xs: 'none', sm: 'block' },
              fontSize: { xs: '1.1rem', sm: '1.2rem' }
            }}
          >
            •
          </Typography>
          </Box>
          <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 1
    }}>
          <Typography variant="h6" color="text.secondary"
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
          >
            {convertAmenityToNumber(propertyData.amenities.shower)} bathrooms
          </Typography>
          <Typography variant="h6" color="text.secondary" >
            •
          </Typography>
          </Box>
          <Typography variant="h6" color="text.secondary">
            {convertAmenityToNumber(propertyData.amenities.kitchen)}  kitchens
          </Typography>
        </Box>

        {/* Distance Information */}
        <Box sx={{ mb: 4 }}>
{propertyData?.distanceMatrix?.length>0&&<Box sx={{ 
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mb: 3
  }}>
    <Typography variant="h6">Distance from</Typography>
    <FormControl sx={{ minWidth: 200 }}>
      <Select
        size="small"
        value={selectedCollege?.college?.id || ''}
        onChange={(e) => {
          const college = propertyData.distanceMatrix.find(
            item => item.college.id === e.target.value
          );
          setSelectedCollege(college);
          setSelectedCampus(null);
        }}
        displayEmpty
      >
        <MenuItem value="">
          <em>Select College</em>
        </MenuItem>
        {propertyData.distanceMatrix.map((item) => (
          <MenuItem key={item.college.id} value={item.college.id}>
            {item.college.collegeName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {selectedCollege && (
      <FormControl sx={{ minWidth: 200 }}>
        <Select
          size="small"
          value={selectedCampus?.campus?.id || ''}
          onChange={(e) => {
            const campus = selectedCollege.campuses.find(
              c => c.campus.id === e.target.value
            );
            setSelectedCampus(campus);
          }}
          displayEmpty
        >
          <MenuItem value="">
            <em>Select Campus</em>
          </MenuItem>
          {selectedCollege.campuses.map((item) => (
            <MenuItem key={item.campus.id} value={item.campus.id}>
              {item.campus.campusName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
  </Box>}

  {selectedCampus && (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 7,
      flexWrap: 'wrap',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DirectionsWalk />
        <Box>
          <Typography variant="h6">Walking</Typography>
          <Typography variant="body2" color="text.secondary">
            {formatTime(selectedCampus.distance.walking.time)} ({formatDistance(selectedCampus.distance.walking.distance)})
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DirectionsCar />
        <Box>
          <Typography variant="h6">Driving</Typography>
          <Typography variant="body2" color="text.secondary">
            {formatTime(selectedCampus.distance.driving.time)} ({formatDistance(selectedCampus.distance.driving.distance)})
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DirectionsBus />
        <Box>
          <Typography variant="h6">Transit</Typography>
          <Typography variant="body2" color="text.secondary">
            {formatTime(selectedCampus.distance.transit.time)} ({formatDistance(selectedCampus.distance.transit.distance)})
          </Typography>
        </Box>
      </Box>
    </Box>
  )}
</Box>

        {/* Description */}
        <Typography variant="h6" gutterBottom
            sx={{ 
              fontSize: { xs: '1.1rem', sm: '1.25rem' },
              mt: { xs: 2, sm: 0 }
            }}
        >
          Description
        </Typography>

        {propertyData.description && propertyData.description.trim() && (
          <>
            <Typography
              variant="body1"
              sx={{
                mb: 2,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: expanded ? 'unset' : 3,
                WebkitBoxOrient: 'vertical',
                wordSpacing: '0.2rem',
                fontSize: { xs: '0.875rem', sm: '1rem' },
                lineHeight: { xs: 1.5, sm: 1.75 }
              }}
            >
              {propertyData.description}
            </Typography>
            {propertyData.description.length > 300 && (
              <Button 
                onClick={() => setExpanded(!expanded)}
                sx={{ 
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  p: { xs: 0, sm: 1 }
                }}
              >
                {expanded ? 'Show Less' : 'Show More'}
              </Button>
            )}
          </>
        )}
      </Grid>

      {/* Right Column - Booking Card */}
      <Grid item xs={12} md={4}>
  <Card
    sx={{
      p: 3,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      borderRadius: 2,
    }}
  >
    {/* Price Header */}
    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
      {priceFormattingSymbol(price, propertyData?.country?.currencyCode)} {}/{selectedRoom?.bedRatePer || 'month'}
    </Typography>

    {/* Available Dates Section */}
    {/* {selectedRoom?.bookingAvailable && ( */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Box sx={{ mr: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CalendarToday sx={{ fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="subtitle1" fontWeight="medium">Available Dates</Typography>
          <Typography variant="body2" color="text.secondary">
            {formatDateRange(
              new Date().toLocaleDateString(), 
              selectedRoom?.endDate?.formatted || 'N/A'
            )}
          </Typography>
        </Box>
      </Box>
    {/* )} */}

    {/* Check-in Date Selector */}
    <Box sx={{ mb: 2 }}>
      {/* <Typography variant="body2" fontWeight="medium" sx={{ mb: 1 }}>Check-in Date</Typography> */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            // border: '1px solid',
            // borderColor: 'divider',
            borderRadius: 1,
            p: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            // overflow: 'hidden'
          }}
        >
          <DatePicker
              label="Check-in Date"
              value={startDate ? dayjs(startDate) : null}
              onChange={(newValue) => {
                if (!newValue || !newValue.isValid()) return;
                handleDateChange(newValue.format("YYYY-MM-DD"));
              }}
              minDate={dayjs(getTodayFormatted())}
              maxDate={
                selectedRoom?.endDate?.formatted
                  ? dayjs(selectedRoom.endDate.formatted.split(" ")[0])
                  : null
              }
              format="DD/MM/YYYY"
              sx={{ width: '100%' }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  InputProps: {
                    readOnly: true, // Prevents keyboard input
                  },
                  // Disable increment/decrement with arrow keys
                  onKeyDown: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                },
                field: {
                  readOnly: true, // Another layer of protection against input
                }
              }}
            />
        </Box>
      </LocalizationProvider>
    </Box>

    {/* Lease Period Info */}
    {startDate && selectedRoom && (
      <>
        <Box sx={{
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
        }}>
          <Grid container>
            <Grid item xs={6} sx={{ p: 1, borderRight: '1px solid', borderColor: 'divider' }}>
              <Typography variant="body2" color="text.secondary">Lease start</Typography>
              <Typography fontWeight="medium">
                {formatDateToDDMMYYYY(calculateLeaseStartDate(startDate))}
              </Typography>
            </Grid>
            <Grid item xs={6} sx={{ p: 1 }}>
              <Typography variant="body2" color="text.secondary">Lease End</Typography>
              <Typography fontWeight="medium">
                {selectedRoom?.endDate?.formatted
                  ? formatDateToDDMMYYYY(selectedRoom.endDate.formatted)
                  : 'N/A'}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Lease Duration */}
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="subtitle1">Lease Duration</Typography>
          <Typography variant="subtitle1">
            {calculateLeaseDuration(
              calculateLeaseStartDate(startDate),
              selectedRoom?.endDate?.formatted
            )} Months
          </Typography>
        </Box>
      </>
    )}

    {/* Room Type Selection */}
    <Box sx={{ mb: 3 }}>
      {/* <Typography variant="body2" fontWeight="medium" sx={{ mb: 1 }}>Select Room Type</Typography> */}
      <FormControl fullWidth variant="outlined">
        <InputLabel id="room-type-label">Select room type</InputLabel>
        <Select
          labelId="room-type-label"
          value={selectedRoom?.id || ''}
          onChange={(e) => {
            const selectedBedId = e.target.value;
            const selectedBed = rooms
              .flatMap(room => room.beds.list)
              .find(bed => bed.id === selectedBedId) || null;
            onRoomSelect(selectedBed);
          }}
          label="Select room type"
          displayEmpty
          inputProps={{ 'aria-label': 'Select room type' }}
          sx={{
            color: 'primary.main',
            fontWeight: 'medium',
            '& .MuiSelect-select': {
              p: 1.6 // reduced from 2 to 1
            }
          }}
          IconComponent={ExpandMore}
        >
          {rooms.map((room) =>
            room.beds.list.map((bed) => (
              <MenuItem key={bed.id} value={bed.id}>
                {room.description} - {bed.description}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Box>

    {/* Price Calculation */}
    <Box sx={{ mb: 4 }}>
      {/* Monthly Rent Display */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <Typography>
        <Tooltip title={propertyData?.isBillIncluded === 1 ? "Bills Included" : "Bills Not Included"}>
          Monthly Rent{' '}
            <span style={{ cursor: 'pointer', color: 'inherit' }}>*</span>
          </Tooltip>
        </Typography>
        <Typography color="success.main" fontWeight="medium">
          {priceFormattingSymbol(price, propertyData?.country?.currencyCode)}
        </Typography>
      </Box>

      {/* Security Deposit */}
      {propertyData?.managingType?.code === 'one_time' ? (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography>Service Charge</Typography>
          <Typography>
            {priceFormattingSymbol(propertyData?.paymentTerms?.serviceCharge || 0, propertyData?.country?.currencyCode)}
          </Typography>
        </Box>
      ) : (
        propertyData?.paymentTerms?.deposit?.months > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography>
              Security Deposit {propertyData?.paymentTerms?.deposit?.refundable ? '(Refundable)' : ''}
            </Typography>
            <Typography>
              {priceFormattingSymbol(price * propertyData?.paymentTerms?.deposit?.months, propertyData?.country?.currencyCode)}
            </Typography>
          </Box>
        )
      )}

      {/* Total Amount */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        mt: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}>
        <Typography fontWeight="bold" variant="subtitle1">Total Initial Payment</Typography>
        <Typography fontWeight="bold" variant="subtitle1">
          {priceFormattingSymbol(
            selectedRoom?.paymentSplit?.totalAmount || (price + (price * (propertyData?.paymentTerms?.deposit?.months || 0))),
            propertyData?.country?.currencyCode
          )}
        </Typography>
      </Box>
    </Box>

    {/* Action Buttons */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {selectedRoom?.bookingAvailable && (
        <Button 
          variant="contained" 
          color="primary" 
          fullWidth 
          size="large"
          disabled={!selectedRoom}
          onClick={() => handleOpenBooking(false)}
          sx={{ 
            bgcolor: 'primary.dark', 
            color: 'white',
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem'
          }}
        >
          Book Now
        </Button>
      )}
      
      <Button 
        variant="text"
        color="primary" 
        fullWidth 
        size="large"
        onClick={() => handleOpenBooking(true)}
        sx={{ 
          textTransform: 'none',
          fontSize: '1rem'
        }}
      >
        Enquire now
      </Button>
    </Box>
  </Card>
</Grid>
      <BookingModal
        open={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        selectedRoom={selectedRoom}
        propertyData={propertyData}
        isEnquiry={isEnquiry}
        propertyId={propertyId}
        defaultStartDate={defaultStartDate} // Add this prop
        setFromDate={setFromDate} // Add this prop
      />
    </Grid>
  );
};

const Amenities = ({ amenities }) => {
  if (!amenities) return null;

  const amenityList = [
    { key: 'living', label: 'Living Room', icon: <Weekend /> },
    { key: 'shower', label: 'Shower', icon: <Bathtub /> },
    { key: 'kitchen', label: 'Kitchen', icon: <Kitchen /> },
    { key: 'parking', label: 'Parking', icon: <LocalParking /> },
    { key: 'wifi', label: 'Free WiFi', icon: <Wifi /> },
    { key: 'couple', label: 'Couple Friendly', icon: <KingBed /> },
    { key: 'heating', label: 'Heating', icon: <Hvac /> },
    { key: 'ac', label: 'Air Conditioning', icon: <AcUnit /> },
    { key: 'fridge', label: 'Fridge', icon: <Kitchen /> },
    { key: 'freezer', label: 'Freezer', icon: <Kitchen /> },
    { key: 'wmachine', label: 'Washing Machine', icon: <LocalLaundryService /> },
    { key: 'dryer', label: 'Dryer', icon: <DryCleaningOutlined /> },
    { key: 'ctop', label: 'Cooktop', icon: <Kitchen /> },
    { key: 'micoven', label: 'Microwave', icon: <Microwave /> },
    { key: 'tv', label: 'TV', icon: <Tv /> },
    { key: 'dishwasher', label: 'Dishwasher', icon: <Kitchen /> },
    { key: 'brgarden', label: 'Garden', icon: <Deck /> },
    { key: 'noSmoking', label: 'No Smoking', icon: <SmokingRooms /> },
    { key: 'communalLaundry', label: 'Communal Laundry', icon: <LocalLaundryService /> },
  ];

  const availableAmenities = amenityList.filter(item => {
    const value = amenities[item.key];
    return value === '1' || 
           value === 1 || 
           (typeof value === 'string' && value.toLowerCase() === 'yes') ||
           (!isNaN(value) && parseInt(value) > 0);
  }).map(item => ({
    ...item,
    count: !isNaN(amenities[item.key]) ? parseInt(amenities[item.key]) : null
  }));

  return (
<Box>
  <Typography 
    variant="h3" 
    gutterBottom 
    sx={{ 
      mt: { xs: 2, sm: 3 },
      mb: { xs: 1.5, sm: 2 },
      fontSize: { xs: '1.5rem', sm: '2rem' }
    }}
  >
    Amenities
  </Typography>
  <Grid container spacing={{ xs: 1.5, sm: 3 }}>
    {availableAmenities.map((item) => (
      <Grid item xs={6} sm={4} md={3} key={item.label}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.75, sm: 1 },
            p: { xs: 1.5, sm: 2 },
            borderRadius: 1,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            minHeight: { xs: 56, sm: 64 },
            flexWrap: 'nowrap'
          }}
        >
          {React.cloneElement(item.icon, {
            sx: { 
              color: 'primary.main',
              fontSize: { xs: 20, sm: 24 }
            },
          })}
          <Typography 
            variant="body2"
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              lineHeight: 1.2,
              flexShrink: 1,
              wordBreak: 'break-word'
            }}
          >
            {item.label}
            {item.count > 1 && ` (${item.count})`}
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
</Box>
  );
};

const Location = ({ propertyData }) => {
  const propertyLocation = {
    lat: parseFloat(propertyData.lat) || 0,
    lng: parseFloat(propertyData.lng) || 0,
    address: `${propertyData.town}, ${propertyData.postCode || 'N/A'}`,
  };

  const [showInfo, setShowInfo] = useState(false);

  const mapContainerStyle = {
    height: '400px',
    width: '100%',
    borderRadius: '8px'
  };

  return (
    <Box>
      <Typography variant="h3" gutterBottom sx={{ mt: 3, mb: 2 }}>
        Location
      </Typography>

      <Box sx={{ height: '400px', mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <LoadScript googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={propertyLocation}
            zoom={15}
            options={{
              styles: [],
              fullscreenControl: false,
              streetViewControl: false
            }}
          >
            <Marker
              position={propertyLocation}
              onClick={() => setShowInfo(true)}
            >
              {showInfo && (
                <InfoWindow
                  position={propertyLocation}
                  onCloseClick={() => setShowInfo(false)}
                >
                  <Typography variant="body2">
                    {propertyLocation.address}
                  </Typography>
                </InfoWindow>
              )}
            </Marker>
          </GoogleMap>
        </LoadScript>
      </Box>
    </Box>
  );
};
const RoomTypes = ({ onRoomSelect, selectedRoom, rooms, propertyData, propertyId,defaultStartDate,setFromDate }) => {
  if (!rooms || rooms.length === 0) return null;
  const [imageError, setImageError] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedBed, setSelectedBed] = useState(null);
  const [isEnquiry, setIsEnquiry] = useState(false);
  const handleRoomClick = (bed,enquiry) => {
    setSelectedBed(bed);
    onRoomSelect(bed);
    setIsEnquiry(enquiry);
    setIsBookingModalOpen(true);
  };


  return (
    <Box>
      <Typography variant="h3" gutterBottom sx={{ mt: 3, mb: 2 }}>
        Room Types
      </Typography>
      <Stack spacing={4}>
        {rooms.map((room) => (
          room?.beds?.total>0&&<Box key={room.roomTitle}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                {room.description}
              </Typography>
              {getRoomGender(room) && (
                <Chip
                  size="small"
                  label={`${getRoomGender(room).charAt(0).toUpperCase() + getRoomGender(room).slice(1)} Only`}
                  color={getRoomGender(room) === 'male' ? 'primary' : 'error'}
                  variant="outlined"
                  sx={{ height: 24 }}
                />
              )}
            </Box>

            <Grid container spacing={3}>
              {room.beds.list.map((bed) => (
                <Grid item xs={12} sm={4} md={3} key={bed.id}>
                  <Card sx={{
                    p: 0,
                    // border: selectedRoom?.id === bed.id ? `2px solid ${propertyData.active ? 'primary.main' : 'grey.500'}` : '1px solid grey',
                    border: selectedRoom?.id === bed.id ? '2px solid' : '1px solid',
                    borderColor: selectedRoom?.id === bed.id ? propertyData.active ? 'primary.main' : 'grey.500' : 'grey.100',
                  }}>
                    <CardContent>
                      {/* Bed Image */}
                      {/* {!imageError && propertyData.image?.imageUrls[0]?.url ? (
                      <CardMedia
                        component="img"
                        height="140"
                        image={propertyData.image.imageUrls[0].url}
                        alt="Room Image"
                        sx={{ borderRadius: 1, objectFit: 'cover' }}
                        onError={() => setImageError(true)}
                      />
                    ) : (
                      <NoImageFound width={300} height={200} />
                    )} */}

                      {/* Bed Details */}
                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="h6">{bed.description}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {!defaultStartDate&& 'From '}{priceFormattingSymbol(bed?.paymentSplit?.bedRatePerMonth, propertyData?.country?.currencyCode)}/{bed.bedRatePer}
                                {!defaultStartDate && (
                                  <Tooltip title="Select a check-in date to show accurate dates" arrow>
                                    <Info sx={{ ml: 0.5, verticalAlign: 'middle', cursor: 'pointer', fontSize: '13px' }} />
                                  </Tooltip>
                                )}
                              </Typography>
                          </Box>
                          <Chip label={bed.isAllotted ? 'Allotted' : 'Available'} size="small" color={bed.isAllotted ? 'warning' : 'success'} variant='outlined'></Chip>
                        </Box>
                        {bed.startDate && bed.endDate && (
                          <Box sx={{ 
                            mt: 2,
                            p: 1.5,
                            // bgcolor: 'grey.50',
                            borderRadius: 1,
                            border: '1px solid',
                            borderColor: 'divider'
                          }}>
                            <Typography variant="caption" color="text.secondary" display="block">
                              Available From
                            </Typography>
                            <Typography variant="body2">
                              {formatDateRange(new Date() ,bed.endDate.formatted)}
                            </Typography>
                          </Box>
                        )}
                        {/* Current Tenant (if allocated) */}
                        {bed.isAllotted === 1 && bed.tenancy?.studentDetails && (
                          <>
                            <Divider sx={{ my: 2 }} />
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 1 }}
                            >
                              Occupied by
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>

                            {bed.tenancy.studentDetails.gender?.toLowerCase() === 'male' ? (
                                <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main', color: 'white' }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.8 61.8" id="Avatar">
                                    <g fill="#167ffc" class="color000000 svgShape">
                                      <g fill="#167ffc" class="color000000 svgShape">
                                        <circle cx="30.9" cy="30.9" r="30.9" fill="#fe9526" class="colorffc200 svgShape"></circle>
                                        <path fill="#595bd4" fill-rule="evenodd" d="M52.587 52.908a30.895 30.895 0 0 1-43.667-.291 9.206 9.206 0 0 1 4.037-4.832 19.799 19.799 0 0 1 4.075-2.322c-2.198-7.553 3.777-11.266 6.063-12.335 0 3.487 3.265 1.173 7.317 1.217 3.336.037 9.933 3.395 9.933-1.035 3.67 1.086 7.67 8.08 4.917 12.377a17.604 17.604 0 0 1 3.181 2.002 10.192 10.192 0 0 1 4.144 5.22z" class="color677079 svgShape"></path>
                                        <path fill="#f9d0a4" fill-rule="evenodd" d="M24.032 38.68l14.92.09v3.437l-.007.053a2.784 2.784 0 0 1-.07.462l-.05.341-.03.071c-.966 5.074-5.193 7.035-7.803 8.401-2.75-1.498-6.638-4.197-6.947-8.972l-.013-.059v-.2a8.897 8.897 0 0 1-.004-.207c0 .036.003.07.004.106z" class="colorf9dca4 svgShape"></path>
                                        <path fill-rule="evenodd" d="M38.953 38.617v4.005a7.167 7.167 0 0 1-.095 1.108 6.01 6.01 0 0 1-.38 1.321c-5.184 3.915-13.444.704-14.763-5.983z" opacity=".11" fill="#167ffc" class="color000000 svgShape"></path>
                                        <path fill="#f9d0a4" fill-rule="evenodd" d="M18.104 25.235c-4.94 1.27-.74 7.29 2.367 7.264a19.805 19.805 0 0 1-2.367-7.264zM43.837 25.235c4.94 1.27.74 7.29-2.368 7.263a19.8 19.8 0 0 0 2.368-7.263z" class="colorf9dca4 svgShape"></path>
                                        <path fill="#ffdfbe" fill-rule="evenodd" d="M30.733 11.361c20.523 0 12.525 32.446 0 32.446-11.83 0-20.523-32.446 0-32.446z" class="colorffe8be svgShape"></path>
                                        <path fill="#8a6742" fill-rule="evenodd" d="M21.047 22.105a1.738 1.738 0 0 1-.414 2.676c-1.45 1.193-1.503 5.353-1.503 5.353-.56-.556-.547-3.534-1.761-5.255s-2.032-13.763 4.757-18.142a4.266 4.266 0 0 0-.933 3.6s4.716-6.763 12.54-6.568a5.029 5.029 0 0 0-2.487 3.26s6.84-2.822 12.54.535a13.576 13.576 0 0 0-4.145 1.947c2.768.076 5.443.59 7.46 2.384a3.412 3.412 0 0 0-2.176 4.38c.856 3.503.936 6.762.107 8.514-.829 1.752-1.22.621-1.739 4.295a1.609 1.609 0 0 1-.77 1.214c-.02.266.382-3.756-.655-4.827-1.036-1.07-.385-2.385.029-3.163 2.89-5.427-5.765-7.886-10.496-7.88-4.103.005-14 1.87-10.354 7.677z" class="color8a5c42 svgShape"></path>
                                        <path fill="#434355" fill-rule="evenodd" d="M19.79 49.162c.03.038 10.418 13.483 22.63-.2-1.475 4.052-7.837 7.26-11.476 7.26-6.95-.02-10.796-5.6-11.154-7.06z" class="color434955 svgShape"></path>
                                        <path fill="#53d86a" fill-rule="evenodd" d="M36.336 61.323c-.41.072-.822.135-1.237.192v-8.937a.576.576 0 0 1 .618-.516.576.576 0 0 1 .619.516v8.745zm-9.82.166q-.622-.089-1.237-.2v-8.711a.576.576 0 0 1 .618-.516.576.576 0 0 1 .62.516z" class="colore6e6e6 svgShape"></path>
                                      </g>
                                    </g>
                                  </svg>
                                </Avatar>
                              ) : bed.tenancy.studentDetails.gender?.toLowerCase() === 'female' ? (
                                <Avatar sx={{ width: 40, height: 40, bgcolor: 'error.main', color: 'white' }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.8 61.8" id="Avatar">
                                    <g fill="#4285f4" class="color000000 svgShape">
                                      <g fill="#4285f4" class="color000000 svgShape">
                                        <path fill="#ffeebe" fill-rule="evenodd" d="M31.129 8.432c21.281 0 12.987 35.266 0 35.266-12.266 0-21.281-35.266 0-35.266z" class="colorffe8be svgShape"></path>
                                        <circle cx="30.9" cy="30.9" r="30.9" fill="#fbbc05" class="colora9cf54 svgShape"></circle>
                                        <path fill="#2e332f" fill-rule="evenodd" d="M16.647 25.104s1.394 18.62-1.98 23.645 16.51-.19 16.51-.19l.006-34.863z" class="color302e33 svgShape"></path>
                                        <path fill="#2e332f" fill-rule="evenodd" d="M45.705 25.104s-1.394 18.62 1.981 23.645-16.51-.19-16.51-.19l-.006-34.863z" class="color302e33 svgShape"></path>
                                        <path fill="#f9e3a4" fill-rule="evenodd" d="M52.797 52.701c-.608-1.462-.494-2.918-5.365-5.187-2.293-.542-8.21-1.319-9.328-3.4-.567-1.052-.43-2.535-.43-5.292l-12.93-.142c0 2.777.109 4.258-.524 5.298-1.19 1.957-8.935 3.384-11.338 4.024-4.093 1.819-3.625 2.925-4.165 4.406a30.896 30.896 0 0 0 44.08.293z" class="colorf9dca4 svgShape"></path>
                                        <path fill-rule="evenodd" d="m37.677 38.778-.015 2.501a5.752 5.752 0 0 0 .55 3.011c-4.452 3.42-12.794 2.595-13.716-5.937z" opacity=".11" fill="#4285f4" class="color000000 svgShape"></path>
                                        <path fill="#f9e3a4" fill-rule="evenodd" d="M19.11 24.183c-2.958 1.29-.442 7.41 1.42 7.383a30.842 30.842 0 0 1-1.42-7.383zM43.507 24.182c2.96 1.292.443 7.411-1.419 7.384a30.832 30.832 0 0 0 1.419-7.384z" class="colorf9dca4 svgShape"></path>
                                        <path fill="#ffeebe" fill-rule="evenodd" d="M31.114 8.666c8.722 0 12.377 6.2 12.601 13.367.307 9.81-5.675 21.43-12.6 21.43-6.56 0-12.706-12.018-12.333-21.928.26-6.953 3.814-12.869 12.332-12.869z" class="colorffe8be svgShape"></path>
                                        <path fill="#34a853" fill-rule="evenodd" d="M31.183 13.697c-.579 2.411-3.3 10.167-14.536 11.407C15.477 5.782 30.182 6.256 31.183 6.311c1.002-.055 15.707-.53 14.536 18.793-11.235-1.24-13.957-8.996-14.536-11.407z" class="color464449 svgShape"></path>
                                        <path fill="#ea4335" fill-rule="evenodd" d="M52.797 52.701c-14.87 4.578-34.168 1.815-39.915-4.699-4.093 1.819-3.625 2.925-4.165 4.406a30.896 30.896 0 0 0 44.08.293z" class="colore9573e svgShape"></path>
                                        <path fill="#ea4335" fill-rule="evenodd" d="m42.797 46.518 1.071.253-.004 8.118h-1.067v-8.371z" class="colore9573e svgShape"></path>
                                        <path fill="#34a853" fill-rule="evenodd" d="M23.834 44.42c.002.013.878 4.451 7.544 4.451 6.641 0 7.046-4.306 7.047-4.318l.188.183c0 .012-.564 4.702-7.235 4.702-6.797 0-7.756-4.83-7.759-4.845z" class="color464449 svgShape"></path>
                                        <ellipse cx="31.324" cy="49.445" fill="#34a853" rx="1.513" ry="1.909" class="color464449 svgShape"></ellipse>
                                      </g>
                                    </g>
                                  </svg>
                                </Avatar>
                              ) : (
                                <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main', color: 'white', fontSize: 12 }}>
                                  {bed.tenancy.studentDetails.name?.charAt(0)}
                                </Avatar>
                              )}
                              <Box>
                                <Typography variant="body2">
                                  {bed.tenancy.studentDetails.name}
                                </Typography>
                                <Box sx={{
                                  display: 'flex',
                                  gap: 2,
                                  mt: 0.5,
                                  fontSize: '0.75rem',
                                  color: 'text.secondary'
                                }}>
                                  <Typography variant="caption">
                                    {bed.tenancy.studentDetails.gender}
                                  </Typography>
                                  <Typography variant="caption">
                                    {bed.tenancy.studentDetails.nationality}
                                  </Typography>
                                  {bed.tenancy.studentDetails.age && <Typography variant="caption">
                                    {bed.tenancy.studentDetails.age} yrs
                                  </Typography>}
                                </Box>
                              </Box>
                            </Box>
                          </>
                        )}

                        {/* Booking Button */}
                        {bed.bookingAvailable && (
                        <Button
                          variant="outlined"
                          color="primary"
                          fullWidth
                          sx={{ mt: 2 }}
                          onClick={() => handleRoomClick(bed, false)}
                          // disabled={bed.isAllotted}
                        >
                          {/* {bed.isAllotted ? 'Allotted' : 'Book Now'} */}
                          { 'Book Now'}

                        </Button>
                      )}
                        <Button
                          variant="outlined"
                          color="primary"
                          fullWidth
                          sx={{ mt: 2 }}
                          onClick={() => handleRoomClick(bed, true)}
                        >
                          Enquire Now
                        </Button>
                        {/* )} */}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Stack>

      <BookingModal
        open={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        selectedRoom={selectedBed}
        propertyData={propertyData}
        isEnquiry={isEnquiry}
        propertyId={propertyId}
        defaultStartDate={defaultStartDate} // Add this prop
        setFromDate={setFromDate}
      />
    </Box>
  );
};


const getTodayFormatted = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const PropertyDetails = () => {
  const [activeSection, setActiveSection] = useState('overview');
  const sectionRefs = useRef({});
  const [showAllImages, setShowAllImages] = useState(false);
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const propertyId = Number(id);
  const [searchParams] = useSearchParams();
  const [fromDate, setFromDate] = useState(searchParams.get('fromDate') || getTodayFormatted())
  const sections = [
    { id: 'overview', label: 'Overview' },
    { id: 'amenities', label: 'Amenities' },
    { id: 'location', label: 'Location' },
    { id: 'roomTypes', label: 'Room Types' },
    // { id: 'roommates', label: 'Current Tenants' },
    // ...(propertyData?.ownerId ? [{ id: 'ownerDetails', label: 'Owner Details' }] : []),
    ...(propertyData?.propertyRules?.length > 0 && 
      propertyData.propertyRules.some(rule => 
        rule.rule && 
        rule.description && 
        Object.values(rule).every(val => val !== null)
      ) ? [{ id: 'houseRules', label: 'House Rules' }] : []),  
      ...(propertyData?.paymentTerms ? [
        { id: 'termsAndCond', label: 'Terms & Conditions' }
      ] : []),  ];
  const [selectedRoom, setSelectedRoom] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeStep, setActiveStep] = useState(0);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isEnquiry, setIsEnquiry] = useState(false);
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const response = await fget({ url: `/api/v2/properties/${propertyId}`,  params: fromDate ? { fromDate } : undefined  });
        if (response.data.status === 'Success') {
          setPropertyData(response.data.property);
          // Select the first available room
          const firstRoom = response.data.property.rooms?.[0];
          const firstBed = firstRoom?.beds?.list?.[0];
          setSelectedRoom(firstBed);
        } else {
          throw new Error('Failed to fetch property data');
        }
      } catch (error) {
        console.error('Fetch Property Data Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyData();
  }, [propertyId,fromDate]);

  const [failedImages, setFailedImages] = useState({});


  const handleSectionChange = (event, newSection) => {
    if (newSection !== null) {
      setActiveSection(newSection);
      sectionRefs.current[newSection]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const handleOpenBookingModal = (enquiry) => {
    
    setIsEnquiry(enquiry);
    setIsBookingModalOpen(true);
  };

  const handleImageClick = (imageUrl, index) => {
    setSelectedImage(imageUrl);
    setCurrentImageIndex(index);
    setImagePreviewOpen(true);
  };

  const handleCloseImagePreview = () => {
    setImagePreviewOpen(false);
    setSelectedImage('');
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '80vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!propertyData) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">Property not found.</Typography>
      </Box>
    );
  }

  const visibleImages = showAllImages
    ? propertyData.image?.imageUrls || []
    : propertyData.image?.imageUrls?.slice(0, 6) || [];
  const allImagesFailed = visibleImages.length === 0 ||
    visibleImages.every((_, index) => failedImages[index]);
  return (
    <Box sx={{ p: 0 }}>
      <DashboardCard>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              mb: 2,
            }}
          >
            <Box>
              <Typography variant="h4" gutterBottom>
                {propertyData.propertyName}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOn color="primary" sx={{ fontSize: 20 }} />
                  <Typography variant="subtitle1" color="text.secondary">
                    {propertyData.town}, {propertyData.postCode || 'N/A'}
                  </Typography>
                </Box>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Star sx={{ color: 'warning.main', fontSize: 20 }} />
                  <Typography variant="subtitle1" color="text.secondary">
                    {propertyData.propertyQuality?.toFixed(1) || 'N/A'}
                  </Typography>
                </Box> */}
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
            
            <Chip
              label={propertyData.managingType?.name==="Managing"?"Managed by Autumnrooms": "One-Time"}
              color={propertyData.managingType?.code === 'one_time' ? 'info' : 'primary'}
            />
            <Chip
              label={propertyData.active ? "Active" : "Inactive"}
              color={propertyData.active ? 'success' : 'default'}
            />
            {propertyData?.isBillIncluded !== 0 ? (
                <Chip label="Bills Included" color="info" />
              ) : (
                <Chip label="Bills Not Included" color="default" />
              )}
          </Box>
          </Box>

          <ToggleButtonGroup
            value={activeSection}
            exclusive
            onChange={handleSectionChange}
            sx={{
              display: { xs: 'none', sm: 'flex' }, // Hide on mobile, show on sm and up
              width: { xs: '100%', md: '100%' },
              margin: '0 auto',
              bgcolor: 'grey.100',
              borderRadius: '23px',
              padding: '4px',
              flexWrap: 'wrap',
              gap: { xs: '4px', sm: 1 },
              '& .MuiToggleButton-root': {
                borderRadius: '50px',
                flex: { xs: '1 1 calc(50% - 4px)', sm: 1 },
                minWidth: { xs: '120px', sm: 'fit-content' },
                py: 0.75,
                px: 2,
                textTransform: 'none',
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                color: 'text.secondary',
                whiteSpace: 'nowrap',
                margin: { xs: '2px', sm: 0 },
                border: '1px solid',
                borderColor: { xs: 'transparent', sm: 'divider' },
                '&.Mui-selected': {
                  bgcolor: 'white',
                  color: 'primary.main',
                  // borderColor: 'primary.main',
                  '&:hover': {
                    bgcolor: 'white',
                  },
                },
              },
            }}
          >
            {sections.map((section) => (
              <ToggleButton key={section.id} value={section.id}>
                {section.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>

        {/* Image Gallery */}
        <Box sx={{ mb: 4, position: 'relative' }}>
  {allImagesFailed ? (
    <Box sx={{
      width: '100%',
      height: { xs: 300, sm: 450 },
      borderRadius: 2,
      overflow: 'hidden'
    }}>
      <NoImageFound width="100%" height="100%" />
    </Box>
  ) : isMobile ? (
<Box>
    <Slider
      dots={true}
      infinite={false}
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      arrows={true}
      beforeChange={(current, next) => setActiveStep(next)}
      customPaging={(i) => (
        <Box
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: i === activeStep ? 'primary.main' : 'grey.300',
            mt: 2
          }}
        />
      )}
    >
      {visibleImages.map((item, index) => (
        <Box
          key={index}
          sx={{
            height: 300,
            width: '100%',
            position: 'relative',
            borderRadius: 1,
            overflow: 'hidden'
          }}
        >
          {!failedImages[index] ? (
            <img
              src={item.url}
              alt={`Gallery image ${index}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              onError={() => setFailedImages(prev => ({ ...prev, [index]: true }))}
            />
          ) : (
            <NoImageFound width="100%" height={300} />
          )}
        </Box>
      ))}
    </Slider>
  </Box>
  ) : (
            <ImageList
              sx={{
                width: '100%',
                height: showAllImages ? 'auto' : 410,
                overflow: 'hidden',
                borderRadius: 2,
                transition: 'height 0.3s ease',
                '& .MuiImageListItem-root': {
                  overflow: 'hidden',
                  '&:first-of-type': {
                    borderTopLeftRadius: 8,
                    borderBottomLeftRadius: showAllImages ? 0 : 8,
                  },
                  '&:nth-of-type(4)': {
                    borderTopRightRadius: 8,
                  },
                  '&:last-of-type': {
                    borderBottomRightRadius: 8,
                  },
                },
              }}
              variant="quilted"
              cols={4}
              rowHeight={200}
              gap={8}
            >
              {visibleImages.map((item, index) => (
                <ImageListItem
                  key={index}
                  cols={index === 0 ? 2 : 1}
                  rows={index === 0 ? 2 : 1}
                >
                  {!failedImages[index] ? (
                    <img
                      src={item.url}
                      alt={`Gallery image ${index}`}
                      loading="lazy"
                      onClick={() => handleImageClick(item.url, index)}
                      onError={() => setFailedImages(prev => ({ ...prev, [index]: true }))}
                      style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  ) : (
                    <NoImageFound
                      width={index === 0 ? 400 : 200}
                      height={index === 0 ? 400 : 200}
                    />
                  )}
                </ImageListItem>
              ))}
            </ImageList>
          )}
          {!isMobile&&visibleImages?.length > 5 && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 16,
                right: 16,
                zIndex: 1,
              }}
            >
              <Button
                variant="contained"
                onClick={() => setShowAllImages((prev) => !prev)}
                sx={{
                  borderRadius: 50,
                  px: 3,
                  bgcolor: 'white',
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'white',
                    opacity: 0.9,
                  },
                }}
              >
                {showAllImages
                  ? 'Show Less'
                  : `Show All ${visibleImages?.length} Photos`}
              </Button>
            </Box>
          )}
        </Box>

        {/* Content Sections */}
        {sections.map((section) => (
          <Box
            key={section.id}
            ref={(el) => (sectionRefs.current[section.id] = el)}
            id={section.id}
            sx={{ mb: 4, minHeight: '100px' }}
          >
            {section.id === 'overview' ? (
              <Overview
                selectedRoom={selectedRoom}
                rooms={propertyData.rooms || []}
                onRoomSelect={setSelectedRoom}
                propertyData={propertyData}
                isEnquiry={isEnquiry}
                setIsEnquiry={setIsEnquiry}
                propertyId={propertyId}
                defaultStartDate={fromDate} // Add this prop
                setFromDate={setFromDate}
              />
            ) : section.id === 'amenities' ? (
              <Amenities amenities={propertyData.amenities} />
            ) : section.id === 'location' ? (
              <Location propertyData={propertyData} />
            ) : section.id === 'roomTypes' ? (
              <RoomTypes
                selectedRoom={selectedRoom}
                onRoomSelect={setSelectedRoom}
                rooms={propertyData.rooms || []}
                propertyData={propertyData}
                propertyId={propertyId}
                defaultStartDate={fromDate} // Add this prop
                setFromDate={setFromDate}
              />
            ) :
              section.id === 'roommates' ? (
                <RoomMates rooms={propertyData.rooms || []} />
              ) : section.id === 'ownerDetails' ? (
                <OwnerDetails owner={propertyData.ownerId ? propertyData.ownerDetails : null} />
              ) : section.id === 'houseRules' ? (
                <HouseRules propertyRules={propertyData.propertyRules || []} />
              ) : section.id === 'termsAndCond' ? (
                <PaymentTermsFull propertyType={propertyData?.managingType?.name} />
              ) : (
                <Typography variant="h5" gutterBottom>
                  {section.label}
                </Typography>
              )}
          </Box>
        ))}
      </DashboardCard>
      
      {/* <Footer /> */}

      {/* Image Preview Modal */}
      <Dialog 
  open={imagePreviewOpen} 
  onClose={handleCloseImagePreview}
  maxWidth="xl"
  fullWidth
  PaperProps={{
    sx: {
      bgcolor: 'transparent',
      boxShadow: 'none',
      overflow: 'hidden',
      margin: 0,
      maxHeight: '100vh',
      maxWidth: '100vw !important',
    }
  }}
>
  <DialogContent sx={{ 
    p: 0, 
    position: 'relative',
    bgcolor: 'transparent',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <Box sx={{ position: 'relative', width: 'fit-content' }}>
    <IconButton
          onClick={handleCloseImagePreview}
          sx={{
            position: 'absolute',
            right: -10,  // Stick to right edge
            top: -25,
            bgcolor: 'rgba(0,0,0,0.5)',
            color: 'white',
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.7)'
            },
            zIndex: 2
          }}
        >
          <GridCloseIcon />
        </IconButton>
      
      {/* Previous Button */}
      {currentImageIndex > 0 && (
        <IconButton
          onClick={() => {
            setCurrentImageIndex(prev => prev - 1);
            setSelectedImage(visibleImages[currentImageIndex - 1].url);
          }}
          sx={{
            position: 'absolute',
            left: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            bgcolor: 'rgba(0,0,0,0.3)',
            color: 'white',
            width: 48,
            height: 48,
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.5)',
              transform: 'translateY(-50%) scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
            zIndex: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}
        >
          <KeyboardArrowLeft sx={{ fontSize: 32 }} />
        </IconButton>
      )}

      {/* Next Button */}
      {currentImageIndex < visibleImages.length - 1 && (
        <IconButton
          onClick={() => {
            setCurrentImageIndex(prev => prev + 1);
            setSelectedImage(visibleImages[currentImageIndex + 1].url);
          }}
          sx={{
            position: 'absolute',
            right: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            bgcolor: 'rgba(0,0,0,0.3)',
            color: 'white',
            width: 48,
            height: 48,
            '&:hover': {
              bgcolor: 'rgba(0,0,0,0.5)',
              transform: 'translateY(-50%) scale(1.1)',
            },
            transition: 'all 0.2s ease-in-out',
            zIndex: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}
        >
          <KeyboardArrowRight sx={{ fontSize: 32 }} />
        </IconButton>
      )}
      
      <img
        src={selectedImage}
        alt="Preview"
        style={{
          maxWidth: '95vw',
          maxHeight: '95vh',
          objectFit: 'contain',
          zIndex: 1
        }}
      />
    </Box>
  </DialogContent>
</Dialog>
    </Box>
  );
};

export default PropertyDetails;